export const DEFAULT_PRICE_TABLE = {
  '290': { 1: 290, 3: 750, 5: 1200 },
  '490': { 1: 690, 3: 1690, 5: 2990 },
  '1190': { 1: 1390, 3: 3850, 5: 6600 },
  '9990': { 1: 3990 },
};

export const TARIFF_DATA = {
  '290': {
    price: 290,
    label: '290 ₽ / месяц',
    title: 'Скидки на меню',
    desc: 'Скидка 30% на роллы и запечённые, 20% на сеты.',
    modalText: 'Скидки на меню: роллы - 30%, сеты - 20%.',
    features: [
      'Скидка -30% на все роллы',
      'Скидка -20% на сеты',
    ],
  },
  '490': {
    price: 690,
    label: '690 ₽ / месяц',
    title: 'Скидки + подарочные роллы',
    desc: 'Все скидки + подарочный ролл каждые 15 дней.',
    modalText: 'Скидки на меню: роллы - 30%, сеты - 20% + подарочные роллы каждые 15 дней.',
    features: [
      'Скидка -30% на все роллы',
      'Скидка -20% на сеты',
      'Бесплатный ролл каждые 15 дней',
      'Ролл до 620₽ — любой на выбор',
    ],
  },
  '1190': {
    price: 1390,
    label: '1390 ₽ / месяц',
    title: 'Скидки + сет + кофе + VIP',
    desc: 'Все скидки + подарочный сет + кофе.',
    modalText: 'Скидки на меню: роллы - 30%, сеты - 20% + подарочный сет + кофе + VIP.',
    badge: 'Лучший',
    features: [
      'Скидка -30% на все роллы',
      'Скидка -20% на сеты',
      'Бесплатный сет каждые 30 дней',
      'Сет до 2000₽ — любой на выбор',
      'Доступ в VIP-клуб',
      'Бесплатный кофе к каждому заказу',
    ],
  },
  '9990': {
    price: 3990,
    oldPrice: 9990,
    label: '3 990 ₽',
    title: 'Амбассадор',
    desc: 'Амбассадор — разовый платёж.',
    oneTime: true,
    features: [
      'Все привилегии тарифа 1190 навсегда',
      'Статус «Амбассадор» в личном кабинете',
      'Персональная реферальная ссылка',
      'Вознаграждение за каждого приглашённого друга',
      'Накопление баланса SHC за рефералов',
      'Приоритетная поддержка',
    ],
  },
};

export const PUBLIC_TARIFF_IDS = ['290', '490', '1190'];

export function pricingToTable(pricing) {
  const table = {};
  for (const [key, value] of Object.entries(pricing || {})) {
    table[key] = value.months || { 1: value.price };
  }
  return table;
}

export function getTariffMonthPrice(pricing, tariffId, months = 1) {
  return pricing?.[tariffId]?.months?.[months]
    || pricing?.[tariffId]?.[months]
    || pricing?.[tariffId]?.price
    || DEFAULT_PRICE_TABLE[tariffId]?.[months]
    || 0;
}
